var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"material-icons mr-2",on:{"click":_vm.searchItem}},[_vm._v("search")])])}
var staticRenderFns = []

export { render, staticRenderFns }